import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IDriverType} from '../interfaces'
import {BaseHttp} from "@atl/lacerta-ui-common";

@Injectable({
    providedIn: 'root'
})
export class DriverTypeHttpService extends BaseHttp {

    constructor(private http: HttpClient) {
        super();
    }

    public getDriverTypes(): Observable<IDriverType[]> {
        const url = `${this.apiRoot}/daemons/drivers/types`;
        return this.http.get<IDriverType[]>(url, {withCredentials: true})
    }

    public createDriverType(driverType: IDriverType): Observable<IDriverType> {
        const url = `${this.apiRoot}/daemons/drivers/type`;
        return this.http.post<IDriverType>(url, driverType, {withCredentials: true})
    }

    public editDriverType(id: number, driverType: IDriverType): Observable<IDriverType>  {
        const url = `${this.apiRoot}/daemons/drivers/type/${id}`;
        return this.http.put<IDriverType>(url, driverType, {withCredentials: true})
    }

    public deleteDriverType(id: number): Observable<string> {
        const url = `${this.apiRoot}/daemons/drivers/type/${id}`;
        return this.http.delete(url, {withCredentials: true, responseType: 'text'})
    }
}
